import type { AuthSession } from './types'
import { UserTypes } from '@/types/authorization'

export function canCreateAgentBuilderDashboardDraft(session: AuthSession | null | undefined) {
  return session?.currentUserTypeId === UserTypes.Admin
}

// Server flag from the API's FEATURE_FLAGS CodeBuild variable. Off (or missing) means only
// DI admins can create dashboards, change them through chat, edit their metadata or delete
// them (or their versions); the API enforces the same rule.
export const AGENT_BUILDER_CLIENT_ADMIN_DASHBOARD_EDITING_FLAG = 'agentBuilderClientAdminDashboardEditing'

export function canCreateOrModifyAgentBuilderDashboards(
  session: AuthSession | null | undefined,
  featureFlags: Record<string, boolean> | null | undefined,
) {
  if (session?.currentUserTypeId === UserTypes.Admin) return true
  return featureFlags?.[AGENT_BUILDER_CLIENT_ADMIN_DASHBOARD_EDITING_FLAG] === true
}

// Server flag from the same /di/config/feature-flags parameter. Off (or missing) hides saved views;
// the API also returns 404 for them.
export const AGENT_BUILDER_SAVED_VIEWS_FLAG = 'agentBuilderSavedViews'

export function hasAgentBuilderSavedViews(featureFlags: Record<string, boolean> | null | undefined) {
  return featureFlags?.[AGENT_BUILDER_SAVED_VIEWS_FLAG] === true
}

export function canManageAgentBuilderDashboardAccess(session: AuthSession | null | undefined) {
  return canCreateAgentBuilderDashboardDraft(session)
}

export function canDeleteAgentBuilderDashboard(
  session: AuthSession | null | undefined,
  dashboard: { insertUserId?: string | null } | null | undefined,
  featureFlags: Record<string, boolean> | null | undefined,
) {
  if (!session || !dashboard) return false
  if (session.currentUserTypeId === UserTypes.Admin) return true
  if (!canCreateOrModifyAgentBuilderDashboards(session, featureFlags)) return false
  if (session.currentUserTypeId === UserTypes.ClientAdmin) {
    return !!dashboard.insertUserId && dashboard.insertUserId === session.currentUserId
  }
  return false
}
